import { render, staticRenderFns } from "./referrer-info.vue?vue&type=template&id=a16db6e6&scoped=true&"
import script from "./referrer-info.vue?vue&type=script&lang=js&"
export * from "./referrer-info.vue?vue&type=script&lang=js&"
import style0 from "./referrer-info.vue?vue&type=style&index=0&id=a16db6e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16db6e6",
  null
  
)

export default component.exports